var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"duolian-container bg-white"},[_c('p',{staticClass:"title"},[_vm._v("愿景使命驱动、聚焦经营、组织力提升、模式闭环")]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"center"},[_vm._v("待办")]),_c('div',{staticClass:"center"},[_vm._v("奖惩")]),_c('div',{staticClass:"center"},[_vm._v("重要数据")])])])
}]

export { render, staticRenderFns }